import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useCourseRecommendedPaths } = getCRUDHooks({
  entityName: 'courseRecommendedPath',
  find: ({ courseId }: { courseId: number }) =>
    clientApi.getOCClient().helpers.learningContent.courses.getRecommendedPaths(courseId),
});

// eslint-disable-next-line import/prefer-default-export
export { useCourseRecommendedPaths };
